// @ts-strict-ignore
import { useState } from 'react'

import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'
import { CatalogItemLocation } from '@/shared/types/deprecated-types'
import { TAccessory, TAccessoryGroup, TProductCode } from '@/shared/types/product-types'
import { Radio } from '@/shared/ui'

import { Grid } from './components/Grid'
import { Slides } from './components/Slides'

import styles from './AccessoriesCarousel.module.scss'

export type AccessoriesCarouselProps = {
	items: TAccessoryGroup[]
	catalogItemType?: any
	relatedId?: number
	tabButtonType?: `link` | `button`
	grid?: boolean
	location?: `${CatalogItemLocation}`
}

export type SlideProps = {
	items: TAccessory[]
	catalogItemType: any
	sectionName: string
	sectionId: number
	mainProductCode?: TProductCode
	relatedId?: number
	location?: `${CatalogItemLocation}`
	noWrap?: boolean
}

/**
 * A carousel of mini accessory cards with a rubric.
 * @param items
 * @param catalogItemType
 * @param relatedId
 * @param tabButtonType
 * @param grid
 * @param location – Component location (Need for GTM)
 */
export const AccessoriesCarousel = ({
	items,
	catalogItemType,
	relatedId,
	tabButtonType,
	grid,
	location
}: AccessoriesCarouselProps): JSX.Element => {
	const filteredItems = items.filter(item => item.SECTION_NAME !== `Сервисы и страхование`)

	const firstSectionId = filteredItems.length > 0 ? filteredItems[0].SECTION_ID.toString() : ''
	const [activeKey, setActiveKey] = useState<string>(firstSectionId)

	const carouselClasses = [styles.accessoriesCarousel, tabButtonType === 'button' && styles.tabButtonType]
		.filter(Boolean)
		.join(' ')

	const handleChange = (e: { target: { value: string } }) => {
		setActiveKey(e.target.value)
	}
	const { isDesktop } = useMediaQueries()
	const sectionStyle = isDesktop ? { paddingTop: '20px' } : {}

	return (
		<section className={carouselClasses} style={sectionStyle}>
			{!!filteredItems.length && (
				<>
					<Radio.Group
						className={styles.tabs}
						value={activeKey}
						onChange={handleChange}
						buttonStyle={tabButtonType === 'button' ? 'solid' : 'outline'}>
						{filteredItems.map(({ SECTION_ID, SECTION_NAME }) => (
							<Radio.Button key={SECTION_ID} value={SECTION_ID.toString()}>
								{SECTION_NAME}
							</Radio.Button>
						))}
					</Radio.Group>
					{filteredItems.map(({ ACCESSORIES, SECTION_ID, SECTION_NAME }) => {
						if (activeKey !== SECTION_ID.toString()) {
							return null
						}
						return (
							<div key={SECTION_ID}>
								{!grid ? (
									<Slides
										items={ACCESSORIES}
										catalogItemType={catalogItemType}
										sectionName={SECTION_NAME}
										sectionId={SECTION_ID}
										relatedId={relatedId}
										location={location}
									/>
								) : (
									<Grid
										items={ACCESSORIES}
										catalogItemType={catalogItemType}
										sectionName={SECTION_NAME}
										sectionId={SECTION_ID}
										relatedId={relatedId}
										location={location}
									/>
								)}
							</div>
						)
					})}
				</>
			)}
		</section>
	)
}
